export { RealEstateProperties } from './RealEstateProperties';
